export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14557.328a23d6.jpg";